var _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatureIcon3 = function SvgFeatureIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 120,
    viewBox: "0 0 125 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.2,
    cy: 62.4,
    r: 57.6,
    fill: "#E38BB6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4,
    cy: 60,
    r: 57.6,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 57.6,
    r: 56.6,
    stroke: "#65C9DB",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.761 25L35 58.5003H52.5L35.5018 88L70 50.5558H52.5L64.761 25Z",
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3886 54L63 73.4064H74.9423L68.0433 90L86 68.9376H74.9423L80.3886 54Z",
    stroke: "#E7F58D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFeatureIcon3;